import axios from "axios";
import React, { Component } from "react";

import { Button, Col, Form, Input, Row } from "antd";

const FormItem = Form.Item;

class UnwrappedCartridgeChange extends Component {
  state = {
    loading: false,
    ids: [],
  };

  componentDidMount() {
    axios({
      method: "get",
      url: "/packaging_ids",
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    })
      .then((res) => {
        this.setState({
          ids: res.data,
        });
      })
      .catch(() => {
        alert("Couldn't fetch the ids");
      });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { form } = this.props;
    form.validateFields((err, values) => {
      if (!err) {
        this.setState({ loading: true });
        console.log(values);
        axios({
          method: "post",
          url: "/cartridge_change",
          headers: { Authorization: sessionStorage.getItem("jwtToken") },
          data: {
            ...values,
          },
        })
          .then(() => {
            this.setState(
              {
                loading: false,
              },
              () => alert("Successfully updated!")
            );
            window.location.reload(true);
          })
          .catch(() => {
            this.setState(
              {
                loading: false,
              },
              () => alert("Something went wrong, please try again!")
            );
          });
      }
    });
  };

  render() {
    const { form } = this.props;
    const { loading, ids } = this.state;
    const { getFieldDecorator } = form;

    return (
      <div style={{ marginTop: "10%" }}>
        <Row type="flex" justify="center">
          <Col span={6}>
            <div style={{ marginBottom: "2%" }}>
              <h5>Cartridge ids:</h5>
              {ids.map((id, index) => (
                <p>
                  Cartridge {index + 1}: {id}
                </p>
              ))}
            </div>
          </Col>
          <Col span={6}>
            <Form onSubmit={this.handleSubmit} style={{ textAlign: "center" }}>
              <Row type="flex" justify="center">
                <Col span={12}>
                  <FormItem style={{ textAlign: "center" }}>
                    {getFieldDecorator("car_1", {
                      rules: [
                        {
                          required: true,
                          message: "required",
                        },
                      ],
                    })(<Input placeholder="Cartridge 1" />)}
                  </FormItem>
                </Col>
              </Row>

              <Row type="flex" justify="center">
                <Col span={12}>
                  <FormItem style={{ textAlign: "center" }}>
                    {getFieldDecorator("car_2", {
                      rules: [
                        {
                          required: true,
                          message: "required",
                        },
                      ],
                    })(<Input placeholder="Cartridge 2" />)}
                  </FormItem>
                </Col>
              </Row>

              <Row type="flex" justify="center">
                <Col span={12}>
                  <FormItem style={{ textAlign: "center" }}>
                    {getFieldDecorator("car_3", {
                      rules: [
                        {
                          required: true,
                          message: "required",
                        },
                      ],
                    })(<Input placeholder="Cartridge 3" />)}
                  </FormItem>
                </Col>
              </Row>

              <Row type="flex" justify="center">
                <Col span={12}>
                  <FormItem style={{ textAlign: "center" }}>
                    {getFieldDecorator("car_4", {
                      rules: [
                        {
                          required: true,
                          message: "required",
                        },
                      ],
                    })(<Input placeholder="Cartridge 4" />)}
                  </FormItem>
                </Col>
              </Row>

              <Row type="flex" justify="center">
                <Col span={12}>
                  <FormItem style={{ textAlign: "center" }}>
                    {getFieldDecorator("car_5", {
                      rules: [
                        {
                          required: true,
                          message: "required",
                        },
                      ],
                    })(<Input placeholder="Cartridge 12" />)}
                  </FormItem>
                </Col>
              </Row>

              <FormItem style={{ textAlign: "center" }}>
                <Button type="primary" htmlType="submit" loading={loading}>
                  Submit and create Refill
                </Button>
              </FormItem>
            </Form>
          </Col>
        </Row>
      </div>
    );
  }
}

const CartridgeChange = Form.create()(UnwrappedCartridgeChange);

export default CartridgeChange;



// WEBPACK FOOTER //
// ./src/component/CartridgeChange.js